import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-smile-rating',
  templateUrl: './smile-rating.component.html',
  styleUrls: ['./smile-rating.component.scss'],
})
export class SmileRatingComponent {

  @Input() rate = 0;

  @Output() didRated = new EventEmitter<number>();

  constructor() { }

}
